import type { Handbook } from '../../types/handbook';

export enum HandbookEvents {
  handbookInit = 'handbookInit'
}

export const subscribeToHandbook = (
  callback: (handbook: Handbook | null) => void
) => {
  const handbookHandler = (
    event: CustomEvent<Handbook | null>
  ) => {
    callback(event.detail);
  };

  document.addEventListener(
    HandbookEvents.handbookInit,
    handbookHandler
  );

  return () => {
    document.removeEventListener(
      HandbookEvents.handbookInit,
      handbookHandler
    );
  };
};
